import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MenuModule } from './../menu/menu.module';
import { HeaderComponent } from './header.component';

@NgModule({
  imports: [CommonModule, MenuModule],
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
  bootstrap: [HeaderComponent]
})
export class HeaderModule {}



// WEBPACK FOOTER //
// ./src/app/shared-layout/header/header.module.ts